export const company = {
  name: 'IG Contracting & Foundation Systems LLC',
  shortName: 'IG Foundation Systems',
  tagline: {
    en: 'Your Foundation Starts with Us',
    es: 'Tu Cimiento Comienza con Nosotros',
  },
  phone: '+1 360-463-7104',
  phoneHref: 'tel:+13604637104',
  whatsappHref: 'https://wa.me/13604637104',
  email: 'igenralcontractingllc@gmail.com',
  emailHref: 'mailto:igenralcontractingllc@gmail.com',
  city: 'Shelton, WA',
  state: 'Washington',
  hours: {
    en: 'Mon – Sat, 7:00 AM – 7:00 PM',
    es: 'Lun – Sáb, 7:00 AM – 7:00 PM',
  },
  license: 'Licensed, bonded & insured in Washington State',
  facebook: 'https://facebook.com',
  logo: 'https://cdn.magicpatterns.com/uploads/4VCfcXYQb73qF6RAoB7ULR/Logo.png',
  heroImage:
    'https://cdn.magicpatterns.com/uploads/9wyauUhryYvscd29Pjn4in/Banner_Hero_Fernandito.png',
  teamImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/cf463731-4166-4a8b-a0d7-d0f623b6ad3e.jpg',
  workImage:
    'https://cdn.magicpatterns.com/patterns/generated-images/9d43b830-86fd-47ce-abc6-101c597b74ae.jpg',
}

export const stats = [
  {
    value: '30+',
    label: { en: 'Years Combined Experience', es: 'Años de Experiencia Combinada' },
  },
  {
    value: '1,000+',
    label: { en: 'Washington Homes Protected', es: 'Hogares de Washington Protegidos' },
  },
  {
    value: '100%',
    label: { en: 'Licensed & Insured Crews', es: 'Equipos con Licencia y Seguro' },
  },
  {
    value: '$0',
    label: { en: 'Cost for Home Inspections', es: 'Costo por Inspección del Hogar' },
  },
]
